import { Button, Result } from 'antd';

/**
 * Rendered by <AppInsightsErrorBoundary> when a render-time error escapes the
 * React tree. The error itself is already reported to Application Insights by
 * the boundary, so this is purely the user-facing recovery UI.
 */
const ErrorFallback = () => {
  return (
    <Result
      status="error"
      title="Something went wrong"
      subTitle="An unexpected error occurred. Please reload the page and try again."
      extra={
        <Button type="primary" onClick={() => window.location.reload()}>
          Reload
        </Button>
      }
    />
  );
};

export default ErrorFallback;
